module.exports = __webpack_public_path__ + "static/media/FindandWork.2a2a5ec0.mp4";